<template>
    <div v-if="pending" class="text-center" style="transition: none !important;">
        <b-spinner />
    </div>

    <main v-else>
        <header class="justify-between align-items-stretch mb-3">
            <b-breadcrumb class="flex-grow-1 mb-0">
                <b-breadcrumb-item :to="{ name: 'customers.index' }">
                    {{ $t('Customers') }}
                </b-breadcrumb-item>

                <b-breadcrumb-item active>
                    {{ customerId ? customer.originalData.name : $t('Create') }}
                </b-breadcrumb-item>
            </b-breadcrumb>

            <b-dropdown
                v-if="customerId"
                :id="'customer_actions_dropdown_' + customer.id"
                :title="$t('Actions')"
                class="ml-3"
                right
                no-caret
            >
                <template slot="button-content">
                    <fa icon="ellipsis-v" fixed-width />
                </template>

                <b-dropdown-item variant="danger" @click="handleDelete">
                    <fa icon="trash" fixed-width />
                    {{ $t('Delete') }}
                </b-dropdown-item>
            </b-dropdown>
        </header>

        <b-card class="mb-3" no-body tag="section">
            <b-form
                @submit.prevent="save"
                @keydown="customer.onKeydown($event)"
            >
                <b-card-body>
                    <b-form-group
                        :label="$t('Name')"
                        label-for="name"
                        :state="customer.errors.has('name') ? false : null"
                        :invalid-feedback="customer.errors.get('name')"
                    >
                        <b-form-input
                            id="name"
                            v-model="customer.name"
                            autofocus
                            name="name"
                            :state="customer.errors.has('name') ? false : null"
                        />
                    </b-form-group>
                </b-card-body>

                <b-card-footer>
                    <b-button
                        v-if="!customerId || customer"
                        :disabled="customer.busy"
                        type="submit"
                        variant="primary"
                    >
                        {{ customerId ? $t('Save') : $t('Create') }}
                        <b-spinner v-show="customer.busy" small />
                    </b-button>
                </b-card-footer>
            </b-form>
        </b-card>
    </main>
</template>

<script>
    import Form from 'vform';

    export default {
        name: 'Customer',
        props: {
            customerId: {
                type: [Number, String],
                default: null,
            },
        },
        data() {
            return {
                pending: false,
                customer: new Form({
                    name: null,
                }),
            };
        },
        async beforeRouteEnter(to, from, next) {
            await next(vm => vm.fetchData(to.params.customerId));
        },
        async beforeRouteUpdate(to, from, next) {
            if (to.params.customerId) {
                this.fetchData(to.params.customerId);
            } else {
                this.customer = new Form();
            }
            next();
        },
        methods: {
            async fetchData(customerId) {
                if (!customerId) {
                    return this.setData({});
                }

                if (this.pending) {
                    return;
                }

                this.pending = true;

                let {data} = await this.axios.get('/api/customers/' + customerId);
                this.setData(data);

                this.pending = false;
            },

            async save() {
                if (this.customerId) {
                    await this.handleUpdate();
                } else {
                    await this.handleCreate();
                }

                this.savedToast()
            },

            async handleCreate() {
                let {data} = await this.customer.post('/api/customers');
                this.$router.push({
                    name: 'customers.edit',
                    params: {
                        customerId: data.id,
                    },
                });

                this.$root.$emit('created::customer', data);
            },

            async handleDelete() {

                if (!confirm(this.$t('Are you sure'))) {
                    return;
                }

                await this.axios.delete(`/api/customers/${this.customerId}`);

                this.$root.$emit('deleted::customer', this.customerId);

                this.$router.push({
                    name: 'customers.create',
                });
            },

            async handleUpdate() {
                await this.customer.put('/api/customers/' + this.customerId);
                this.$root.$emit('updated::customer', this.customer.data());
            },

            setData(data) {
                this.customer = new Form(data);
            },
        },
    };
</script>
